import { jsx as _jsx } from "react/jsx-runtime";
const Card = ({ children, wrapperStyles, ...rest }) => {
    return (_jsx("div", { className: `flex flex-col justify-start rounded-lg border border-solid border-slate-300 bg-white p-6 shadow-sm ${wrapperStyles}`, ...rest, children: children }));
};
export default Card;
